<button mat-fab class="!rounded-full">
  <mat-icon fontSet="fa" [fontIcon]="icon"></mat-icon>
</button>
